import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import BannerTitleAndFieldCardFragment from "@coworker/apprestructured/src/task-management/components/TaskCard/card-fragments/BannerTitleAndFieldCardFragment/BannerTitleAndFieldCardFragment";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";
import { TaskType } from "@coworker/apprestructured/src/task-management/types/TaskType";

function BannerTitleAndFieldCardFragmentDemo() {
  const [mediasCount, setMediasCount] = useState(3);

  const medias = Array.from({ length: mediasCount }, (_, i) => ({
    id: `media-${i}`,
    article_id: `70335541-${i}`,
  }));

  const task = { details: { medias } } as unknown as Task;
  const taskType = {} as unknown as TaskType;

  return (
    <Demo>
      <Name>BannerTitleAndFieldCardFragment</Name>
      <Highlight>
        <BannerTitleAndFieldCardFragment
          configProps={{
            field: "details.medias",
            translationKey: "inXLocationsString",
          }}
          commonProps={{ task, taskType }}
        />
      </Highlight>
      <Actions>
        <FixaInputField
          label="Number of locations"
          type="number"
          id="bannertitleandfield-count"
          value={mediasCount.toString()}
          onChange={(e) => setMediasCount(parseInt(e.target.value) || 0)}
          min="0"
          max="10"
        />
      </Actions>
    </Demo>
  );
}

export default memo(BannerTitleAndFieldCardFragmentDemo);
